/*
 * ShiftDetailCardApplications Messages
 *
 * This contains all the text for the ShiftDetailCardApplications component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.ShiftDetailCardApplications.header',
    defaultMessage: 'Applications',
  },
  total: {
    id: 'app.components.ShiftDetailCardApplications.total',
    defaultMessage: '{totalApplications} applications in total',
  },
  assignedApplications: {
    id: 'app.components.ShiftDetailCardApplications.assignedApplications',
    defaultMessage: 'Assigned Applications',
  },
  unassignedApplications: {
    id: 'app.components.ShiftDetailCardApplications.unassignedApplications',
    defaultMessage: 'Unassigned Applications',
  },
});
